import { render, staticRenderFns } from "./SelectedOffer.vue?vue&type=template&id=3851061b&scoped=true&"
import script from "./SelectedOffer.vue?vue&type=script&lang=js&"
export * from "./SelectedOffer.vue?vue&type=script&lang=js&"
import style0 from "./SelectedOffer.vue?vue&type=style&index=0&id=3851061b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3851061b",
  null
  
)

export default component.exports